import { JsonFormsStateProps } from "components/CRPComponents/JsonForm/JsonFormsComponent/types";
import { MDSnackbarProps } from "components/MDSnackbar";
import { ShemaJsonTemplate } from "types/SchemaJson";
import { ApiFinancialRequest } from "data/ApiFinancial";

export interface UseGetItemProps<T> {
  setTemplate: React.Dispatch<React.SetStateAction<ShemaJsonTemplate>>;
  setState: React.Dispatch<React.SetStateAction<JsonFormsStateProps<T>>>;
  queryParam: number | string;
}

export interface UseDeleteProps {
  queryParam: number | string;
  setSnackBarInfo: React.Dispatch<React.SetStateAction<Omit<MDSnackbarProps, "close" | "onClose">>>;
  setEditing: React.Dispatch<React.SetStateAction<boolean>>;
}

export interface UseUpdateProps<T> {
  queryParam: number | string;
  setState: React.Dispatch<React.SetStateAction<JsonFormsStateProps<T>>>;
}

export const ApiRequest = ApiFinancialRequest;

export interface SchemaData {
  active: boolean;
  activateIfPossible: boolean;
  value: number;
  valueWithoutDiscout?: number;
  installments: number;
  eCommerceSkuId?: number;
  eCommerceLastUpdate?: Date;
  planAdmissionWay: {
    title: string;
  };
  commercialConditionId?: number;
  valueOtherInstallments?: number;
  urlInscription?: string;
}

export interface SchemaDataCreate {
  active?: boolean;
  activateIfPossible: boolean;
  value: number;
  valueWithoutDiscout?: number;
  installments: number;
  eCommerceSkuId?: number;
  eCommerceLastUpdate?: Date;
  noPlanAdmissionWays?: boolean;
  noAdmissionWays?: boolean;
  createPlanAdmissionWay?: boolean;
  createAdmissionWay?: boolean;
  commercialConditionId?: number;
  valueOtherInstallments?: number;
  urlInscription?: string;
  planAdmissionWay: {
    id?: number;
    title: string;
    tag?: string;
    admissionWay: {
      id?: number;
      name: string;
      content?: string;
    };
  };
}

export const path = "/ecommerce/investimento";
